"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const Search_1 = __importDefault(require("@mui/icons-material/Search"));
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const react_1 = require("react");
const StyledSearchTableCell_1 = require("../../../../material-ui-theme/components/styled/StyledSearchTableCell");
const zustandStore_1 = require("../../../../zustandStore");
const lexico = new lexico_1.default();
const NameColumn = () => {
    const { setCurrentNameSearchValue } = (0, zustandStore_1.useZustand)();
    const currentNameSearchValue = (0, zustandStore_1.useZustand)(state => state.peopleTable.currentNameSearchValue);
    const [searchVisible, setSearchVisible] = (0, react_1.useState)(false);
    const handleSearchVisibility = () => {
        setSearchVisible(!searchVisible);
    };
    const handleNameChange = event => {
        setCurrentNameSearchValue(event.target.value);
    };
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, onClick: handleSearchVisibility, onBlur: () => {
            if (currentNameSearchValue.length === 0) {
                setSearchVisible(false);
            }
        }, sx: {
            flex: 2,
            alignItems: 'center',
        }, children: (0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, direction: "row", sx: {
                justifyContent: 'flex-start',
                alignItems: 'center',
                gap: 0.5,
            }, children: [(0, jsx_runtime_1.jsx)(Search_1.default, {}), searchVisible ? ((0, jsx_runtime_1.jsx)(StyledSearchTableCell_1.StyledSearchTableCell, { variant: "standard", size: "small", value: currentNameSearchValue, autoFocus: true, onChange: handleNameChange, InputProps: {
                        endAdornment: ((0, jsx_runtime_1.jsx)(material_1.InputAdornment, { position: "end", children: (0, jsx_runtime_1.jsx)(material_1.IconButton, { edge: "end", onClick: () => setCurrentNameSearchValue(''), children: (0, jsx_runtime_1.jsx)(Close_1.default, { fontSize: "small" }) }) })),
                    } })) : ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: currentNameSearchValue || lexico.tr('Name') }))] }) }));
};
const useColumns = () => {
    return [
        {
            id: 'Name',
            searchable: true,
            ui: NameColumn,
        },
        {
            id: 'role',
            ui() {
                return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('Role') }) }));
            },
        },
        {
            id: 'approver',
            ui() {
                return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('Default Approver') }) }));
            },
        },
        {
            id: 'status',
            ui() {
                return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('Status') }) }));
            },
        },
        {
            id: 'teamActions',
            ui() {
                return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "row", sx: {
                        flex: 0.5,
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                    }, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: lexico.tr('Actions') }) }));
            },
        },
    ];
};
exports.useColumns = useColumns;
